import { Deductable } from '../../state/deductable'
import deductables from './data.json'

const activeDeductables = deductables
export async function getActiveDeductables(): Promise<Deductable[]> {
  return new Promise(resolve => {
    resolve(activeDeductables as any)
  })
}
